import { useState, useEffect } from "react";
import { NotificationWidgetStyled } from "./styled";
import { userService } from "apiServices";
import { useNavigate } from "react-router-dom";
import { useComponentVisible } from "utils/functions/detectClickOutside";
import { ROUTE_PATH } from "utils/constants/routePath";
import { useTranslation } from "react-i18next";
import { Icons } from "components";
import moment from "moment";

const NotificationWidget = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["common"]);
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible();

  const [_isAlert, _setIsAlert] = useState(false);
  const [_data, _setData] = useState();

  useEffect(() => {
    _fetchData(
      `?start_date=${moment()
        .startOf("year")
        .format("YYYY-MM-DD")}&end_date=${moment()
        .endOf("year")
        .format("YYYY-MM-DD")}`
    );
  }, []);

  const _fetchData = async (query) => {
    let res = await userService.GET_NOTIFICATION_LIST(query);
    if (res && res.status === 200) {
      let findAlert = res.data.docs.find((e) => !e.is_read);
      _setIsAlert(findAlert ? true : false);
      _setData(res.data);
    }
  };

  const _handleClickNoti = () => {
    setIsComponentVisible(!isComponentVisible);
    if (_isAlert) {
      userService.POST_NOTIFICATION_READ_ALL();
      _setIsAlert(false);
    }
  };

  const _handleClickNotiItem = (e) => {
    _handleClickNoti();
    switch (e.feature_type) {
      case "1":
        navigate(`${ROUTE_PATH.NEW}/${e.feature_id}`);
        break;
      case "2":
        navigate(`${ROUTE_PATH.ACTIVITIES}/${e.feature_id}`);
        break;
      case "3":
        navigate(`${ROUTE_PATH.SPECIAL_POINTS_FAV}/test/${e.feature_id}`);
        break;
      default:
        break;
    }
  };

  return (
    <NotificationWidgetStyled ref={ref}>
      <div className="btn_notification" onClick={_handleClickNoti}>
        {_isAlert ? <Icons.Bell2 color="#FF0000" /> : <Icons.Bell2 />}
      </div>
      {isComponentVisible && (
        <div className="notification_body">
          <div className="noti_header">
            <Icons.Bell2 color="#FFFFFF" /> {t("Notification", { ns: "common" })}
          </div>
          {!_data || _data.docs.length === 0 ? (
            <div className="noti_empty">
              {t("No notificatoin", { ns: "common" })}
            </div>
          ) : (
            _data.docs.map((e, i) => (
              <div
                key={i}
                className="noti_item"
                onClick={() => _handleClickNotiItem(e)}
              >
                <div className="noti_title">{e.title}</div>
                <div
                  className="noti_description"
                  dangerouslySetInnerHTML={{
                    __html: e.message,
                  }}
                />
              </div>
            ))
          )}
        </div>
      )}
    </NotificationWidgetStyled>
  );
};

export default NotificationWidget;
